import React, { useState,useEffect } from "react";
import Userlist from "./renderimage";
import { toast } from "react-toastify";
import Select from "../common/selectcustom1";
import { saveImage } from "../../services/pc";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ImageSelected from "./imageselected";
import Showimage from './modalshowimage'

const Imagelist = ({
  isOpen,
  header,
  onCancel,onConfirm,
  message,
  list,
  id,
  typelist,
  size = "xl",
}) => {
  let extension = "";
  const [formData, setFormData] = useState({});
  const [messageError, setmessageError] = useState({
    imagetypeid: "",
  });
  const [onsave, setonsave] = useState(false);
  const [imageOpen, setimageOpen] = useState(false);
  const [photos, setphotos] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const notifyPhotoSelector = (files) => {
    
    setphotos(files);
  };


  useEffect(() => {
    if (!isOpen) return;
    setFormData({...formData,imagetypeid:0})
    
  }, [isOpen]);


  const confirmUploadImage = async () => {
    const getPhoto = photos.find((x) => x);
    let photoBase64 = "";
    try {
      photoBase64 = getPhoto ? await getPhoto.getFileEncodeDataURL() : "";
    } catch (err) {}

    if (photoBase64.includes("data:image/png;base64,")) {
      extension = "png";
      photoBase64 = photoBase64.replace("data:image/png;base64,", "");
    } else if (photoBase64.includes("data:image/jpg;base64,")) {
      extension = "jpg";
      photoBase64 = photoBase64.replace("data:image/jpg;base64,", "");
    } else if (photoBase64.includes("data:image/jpeg;base64,")) {
      extension = "jpeg";
      photoBase64 = photoBase64.replace("data:image/jpeg;base64,", "");
    }
    if (photoBase64.includes("data:application/pdf;base64,")) {
      extension = "pdf";
      photoBase64 = photoBase64.replace("data:application/pdf;base64,", "");
    }

    const docSave = {id:id,imagetypeid : formData.imagetypeid, extension, imagedata: photoBase64 };
    doSubmit(docSave);
  };

  const [imagesave, setImagesave] = useState({
    extension: "",
    imagedata: null,
  });

  const doSubmit = async (doc) => {   
    try {
      setonsave(true)
    
      const {data: result} = await saveImage(doc,'nps');
       if (result.status==='success') {
        toast.success(result.message);
        setonsave(false)
        onConfirm()
      setphotos([])
        }
      else {
      toast.error(result.message)
      setonsave(false)
      }
    } 
    catch (error) {
     // toast.error("Error");
    }
  
  
  
  }

  const handleSelectChange = (inputKey, data) => {
    if (!data) return;
      setFormData({
        ...formData,
        [inputKey]: JSON.parse(data),
      });
      if (JSON.parse(data) !== 0) {
        setmessageError({ ...messageError, [inputKey]: "" });
      }  
  };
  const handelClose = () => {
    setimageOpen(false);
  };
  const handleOnClick = (image) => {
    setImageUrl(image)
    setimageOpen(true);
  }
  return (
    <div>
      <Showimage isOpen={imageOpen} onCancel={handelClose} list={imageUrl} />

      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>{header}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-auto">
            <Select
                     label="เลือกหน่วยงาน"
                      data={typelist}
                         
                      value={formData.imagetypeid}
                      name={"imagetypeid"}
                      onChange={handleSelectChange}
                      error={messageError.imagetypeid}
                    />

            </div>
            <div className="col-lg-6 content-center">
              { formData.imagetypeid > 0 &&  <ImageSelected
                labelIdle={"Upload รูปภาพ"}
                notifyFileUpload={notifyPhotoSelector}
              />}
              {photos && photos.length > 0 && (
                <div className="col-lg-6 text-center mb-3">
                  {" "}
                  <button
                    type="button"
                    disabled ={onsave}
                    className="btn btn-primary fs-4  p-1"
                    onClick={confirmUploadImage}
                  >
                    <span className="m-3 ">Upload</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          {list && list.length > 0 && <Userlist list={list}  handleOnClick ={handleOnClick} >  </Userlist>}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Imagelist;
